<template>
  <div id="question-buttons" class="flex flex-align-items--center flex-direction-column">
    <div v-for="option in options" class=" question__buttons margin-y-10" :key="option.value">
      <VButton
        :id="`cpquestionbuttons-btn-${option.value}`"
        :text="option.text"
        variant="secondary"
        :active="activeValue(option.value)"
        @click.native="$emit('input', option.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionButtons',
  props: {
    options: {
      type: Array,
      default: () => [
        { text: 'Sim', value: 'yes' },
        { text: 'Não', value: 'no' },
      ],
    },
    value: String,
  },
  methods: {
    activeValue(optionValue) {
      if (Date.parse(this.value)) { // if date
        return new Date(this.value).getTime() === new Date(optionValue).getTime();
      } else {
        return this.value === optionValue;
      }
    },

  }
};
</script>
